import { Table, TableProps } from "antd";
import { title } from "process";
import React, { useEffect, useState } from "react";
import { generateTableColumnFilters } from "../services/services";

const applyServiceLineFilter = (
  filteredResourcesData: any[],
  serviceLineFilter: any
) => {
  return Object.keys(serviceLineFilter).length === 0 ||
    Object.values(serviceLineFilter).every(
      (arr) => Array.isArray(arr) && arr.length === 0
    )
    ? filteredResourcesData
    : filteredResourcesData.filter(
        (item) =>
          serviceLineFilter[item.region_code] &&
          serviceLineFilter[item.region_code].includes(item.service_line_code)
      );
};

const ResourcesTable = ({
  filteredResourcesData,
  serviceLineFilter,
}: {
  filteredResourcesData: any[];
  serviceLineFilter: any;
}) => {
  const [finalData, setFinalData] = useState<any[]>(
    applyServiceLineFilter(filteredResourcesData, serviceLineFilter)
  );

  useEffect(()=>{
    setFinalData( applyServiceLineFilter(filteredResourcesData, serviceLineFilter))
  }, [filteredResourcesData, serviceLineFilter])

  const columns = [
    {
      title: "Client",
      dataIndex: "client_name",
      key: "client_name",
      align: "center",
    },
    {
      title: "Deal Details",
      children: [
        {
          title: "Deal ID",
          dataIndex: "deal_id",
          key: "deal_id",
          align: "center",
        },
        {
          title: "Deal Name",
          dataIndex: "deal_name",
          key: "deal_name",
          // align: "center",
        },
        {
          title: "Deal Stage",
          dataIndex: "deal_stage_name",
          key: "deal_stage_name",
          filters: generateTableColumnFilters(finalData, "deal_stage_name"),
          onFilter: (value: any, record: { deal_stage_name: any; }) => record.deal_stage_name === value,
        },
        {
          title: "Project Start Date",
          dataIndex: "project_start_date",
          key: "project_start_date",
          align: "center",
          render: (value: string) => (value ? value.slice(0, 10) : ""),
        },
        {
          title: "Deal Duration",
          dataIndex: "duration_in_months",
          key: "duration_in_months",
          align: "center",
        },
        {
          title: "Deal Type",
          dataIndex: "deal_type",
          key: "deal_type",
          align: "center",
          filters: generateTableColumnFilters(finalData, "deal_type"),
          onFilter: (value: any, record: { deal_type: any; }) => {
            if (value === "") {
              return !record.deal_type || record.deal_type.trim() === '';
            }
            return record.deal_type === value;
          },
        },
        {
          title: "Engagement Type",
          dataIndex: "engagement_type",
          key: "engagement_type",
          align: "center",
          filters: generateTableColumnFilters(finalData, "engagement_type"),
          onFilter: (value: any, record: { engagement_type: any; }) => {
            if (value === "") {
              return !record.engagement_type || record.engagement_type.trim() === '';
            }
            return record.engagement_type === value;
          },
        },
        {
          title: "Revenue Type",
          dataIndex: "revenue_type",
          key: "revenue_type",
          align: "center",
          filters: generateTableColumnFilters(finalData, "revenue_type"),
          onFilter: (value: any, record: { revenue_type: any; }) => {
            if (value === "") {
              return !record.revenue_type || record.revenue_type.trim() === '';
            }
            return record.revenue_type === value;
          },
        },
      ],
    },
    {
      title: "Resource Details",
      children: [
        {
          title: "Resource - SL",
          dataIndex: "service_line_code",
          key: "service_line_code",
          align: "center",
        },
        {
          title: "Resource Type",
          dataIndex: "resource_type_code",
          key: "resource_type_code",
          align: "center",
          filters: generateTableColumnFilters(finalData, "resource_type_code"),
          onFilter: (value: any, record: { resource_type_code: any; }) => record.resource_type_code === value,
        },
        {
          title: "Region",
          dataIndex: "region_code",
          key: "region_code",
          align: "center",
          filters: generateTableColumnFilters(finalData, "region_code"),
          onFilter: (value: any, record: { region_code: any; }) => record.region_code === value,
        },
        {
          title: "Start Date",
          dataIndex: "start_date",
          key: "start_date",
          render: (value: string) => (value ? value.slice(0, 10) : ""),
          align: "center",
        },
        {
          title: "End Date",
          dataIndex: "end_date",
          key: "end_date",
          render: (value: string) => (value ? value.slice(0, 10) : ""),
          align: "center",
        },
        {
          title: "Duration",
          dataIndex: "duration",
          key: "duration",
          align: "center",
        },
        {
          title: "Resource Requested on",
          dataIndex: "resource_requested_on",
          key: "resource_requested_on",
          render: (value: string) => (value ? value.slice(0, 10) : ""),
          align: "center",
        },
      ],
    },
  ] as const;

  return (
    <div>
      {/* <style>{`
      .custom-ant-table .ant-table-thead > tr > th {
        background-color: #b8e4ff;
      }
      .custom-ant-table .ant-table-tbody > tr > td {
        background-color: #eff8ff;
      }
    `}</style> */}
      <Table
        dataSource={finalData.sort((a, b) => {
          const clientCompare = a.client_name.localeCompare(b.client_name);
          if (clientCompare !== 0) return clientCompare;
          return a.deal_name.localeCompare(b.deal_name);
        })}
        columns={columns as any}
        className="custom-ant-table"
        rowKey={(_record, idx) => (idx !== undefined ? String(idx) : "")}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
};

export default ResourcesTable;
